import React from 'react';
import styles from './Support.module.css';

const Support = () => {
  return (
    <div className={styles.container}>
      <h1>Support</h1>
      <p>
        Need help with Loggable? We're here to assist you. Contact us directly at{' '}
        <a href="mailto:support@loggable.net" className={styles.emailLink}>
          support@loggable.net
        </a>
      </p>

      <div className={styles.contactBox}>
        <h2>How to Contact Us</h2>
        <p>
          Click the email address above or send an email to <strong>support@loggable.net</strong> with 
          details about your inquiry or issue.
        </p>
      </div>

      <h2>Response Time</h2>
      <p>
        We typically respond to support inquiries within 1-2 business days. For urgent matters, 
        please mention "URGENT" in your subject line.
      </p>

      <h2>What to Include</h2>
      <p>
        To help us assist you more efficiently, please include:
      </p>
      <ul>
        <li>A clear description of the issue or question</li>
        <li>Steps to reproduce the problem (if applicable)</li>
        <li>Screenshots or error messages (if relevant)</li>
        <li>Your account email or username</li>
        <li>Device and browser information (if experiencing technical issues)</li>
      </ul>

      <h2>Other Resources</h2>
      <p>
        For account-related questions, billing inquiries, or general information about Loggable, 
        our support team is ready to help. We're committed to providing you with the best experience possible.
      </p>
    </div>
  );
};

export default Support;